import { useFileDownload } from '@/hooks/useFileDownload'

import { Box } from '@chakra-ui/react'

import { FileThumbnail } from '@/components/ui'

import { IncidentNoteVideoPlayer } from '../../add-note/components/IncidentNoteVideoPlayer'
import { RenderMediaFileIProps } from '../../shared/types/feedTypes'
import { FeedImageThumbnail } from './FeedImageThumbnail'
import { FeedPdfThumbnail } from './FeedPdfThumbnail'

export const RenderMediaFile = ({
  file,
  onFileClick,
}: RenderMediaFileIProps) => {
  const { name, url, mimeType } = file
  const { isDownloading, handleDownload } = useFileDownload()

  const handleClick = () => {
    onFileClick(file)
  }

  if (mimeType?.startsWith('image/')) {
    return (
      <Box key={url} onClick={handleClick}>
        <FeedImageThumbnail file={file} />
      </Box>
    )
  } else if (mimeType === 'video/mp4' || mimeType === 'video/quicktime') {
    return (
      <Box key={url} onClick={handleClick}>
        <IncidentNoteVideoPlayer videoUrl={url} />
      </Box>
    )
  } else if (mimeType === 'application/pdf') {
    return (
      <Box key={url} onClick={handleClick}>
        <FeedPdfThumbnail handleClick={handleClick} name={name} />
      </Box>
    )
  }

  // Formats the app cannot render inline are offered as a download
  return (
    <Box key={url}>
      <FileThumbnail
        isDownloading={isDownloading}
        name={name}
        onDownload={() => handleDownload(url, name)}
      />
    </Box>
  )
}
